import axios from 'axios';

import { BASE_API_URL } from '@/constants/configConstants';

export const resendVerificationEmail = (): Promise<void> => {
  return axios.get(`${BASE_API_URL}auth/email/verification/re-send`);
};
